export const contactsData = {
    email: 'navisenthilnadhan@gmail.com',
    phone: '+918667338331',
    address: 'Chennai, India',  

    sheetAPI: ''
}